document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mySwiper", {
    slidesPerView: "auto",
    //spaceBetween: 10,
    centeredSlides: false,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 6
      }
    }
  });
});

$(document).ready(function(){
    $('.team-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1000,
      arrows: false,
      dots: true,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2 }},
        { breakpoint: 575, settings: { slidesToShow: 1 }}
      ]
    });
});


$(document).ready(function(){
    $('.value-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, arrows: false,}}
      ]
    });
});


$(document).ready(function(){
    $('.testimonial-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      //centerPadding: '30px',
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: true,
      arrows: false,
      dots: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 }},
        { breakpoint: 768, settings: { slidesToShow: 1 }}
      ]
    });
});

$(document).ready(function(){
    $('.collection-slide').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 }},
        { breakpoint: 768, settings: { slidesToShow: 1, arrows:false, dots:true }}
      ]
    });
});

document.addEventListener("DOMContentLoaded", function () {
  $('.banner-slider').slick({
    autoplay: true,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var offerBtn = document.getElementById("offerBtn");
  var popup = document.getElementById("offerPopup");
  var closeBtn = document.querySelector(".close-btn");

  if (offerBtn && popup && closeBtn) {
    offerBtn.addEventListener("click", function () {
      popup.style.display = "flex";
    });

    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
    });

    window.addEventListener("click", function (event) {
      if (event.target === popup) {
        popup.style.display = "none";
      }
    });
  }
});

// our piller accordion 
document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll(".accordion-header");
    if (accordions.length > 0) {
        accordions[0].classList.add("active");
        accordions[0].nextElementSibling.style.display = "block";
    }
    accordions.forEach(header => {
        header.addEventListener("click", function () {
            const content = this.nextElementSibling;
            const isActive = this.classList.contains("active");
            document.querySelectorAll(".accordion-content").forEach(item => {
                item.style.display = "none";
            });
            document.querySelectorAll(".accordion-header").forEach(header => {
                header.classList.remove("active");
            });
            if (!isActive) {
                content.style.display = "block";
                this.classList.add("active");
            }
        });
    });
});

// Singal Product fillter none
document.addEventListener("DOMContentLoaded", function() {
    let productCount = document.querySelectorAll('#product-grid .grid__item').length;
    let filterButton = document.querySelector('.facets-container-drawer');
    filterButton.setAttribute("style", "min-height:auto;");
    console.log(productCount);
    if (productCount === 1 && filterButton) {
        filterButton.style.display = "none";
    }
});


 function openTab(event, tabId) {
  // Hide all tab contents
  document.querySelectorAll(".tab-content").forEach((tab) => {
    tab.classList.remove("active");
  });

  // Remove 'active' class from all tab buttons
  document.querySelectorAll(".tab-link").forEach((button) => {
    button.classList.remove("active");
  });

  // Show the selected tab content
  document.getElementById(tabId).classList.add("active");

  // Add 'active' class to the clicked tab button
  event.currentTarget.classList.add("active");
}


// Hover Menu Open
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
